import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * SEO component for managing all meta tags
 * This component ensures that each page has its unique meta tags
 * and prevents conflicts between different Helmet instances
 */
const SEO = ({ 
  title, 
  description, 
  url, 
  image = "https://myfamilymd.org/og.png", 
  imageWidth = "1200", 
  imageHeight = "630",
  type = "website",
  siteName = "myfamilymd",
  twitterCard = "summary_large_image",
  children
}) => {
  // Ensure URL has the correct domain
  const fullUrl = url.startsWith('http') ? url : `https://myfamilymd.org${url}`;
  
  // Get the robots meta value from environment variable or default to index,follow
  const robotsMetaValue = process.env.REACT_APP_ROBOTS_META || 'index,follow';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robotsMetaValue} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:image" content={image} />
      <meta property='og:image:width' content={imageWidth} />
      <meta property='og:image:height' content={imageHeight} />
      <meta property="og:image:secure_url" content={image} />
      
      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:image" content={image} />
      
      {/* Additional meta tags passed as children */}
      {children}
    </Helmet>
  );
};

export default SEO;
